// extracted by mini-css-extract-plugin
export default {"monthText":"MonthlyGain_monthText__uvyaC","percentageText":"MonthlyGain_percentageText__JG4Cr","innerStats":"MonthlyGain_innerStats__k2vzt"};